// extracted by mini-css-extract-plugin
export default {"form":"l4k9qgWw","mobile":"mobile","field":"WQXSdAxX","footer":"rB6EYi54","errorMessage":"S3GV0MaA"};